import { render, staticRenderFns } from "./MatchFightCreateModal.vue?vue&type=template&id=571cc440&scoped=true&"
import script from "./MatchFightCreateModal.vue?vue&type=script&lang=js&"
export * from "./MatchFightCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571cc440",
  null
  
)

export default component.exports